module.exports = __webpack_public_path__ + "static/img/network03.5876519e.png";